import {CHANGE_FIELD, CHANGE_UI, FETCH_CAR_MODEL_DETAILS, RESET_FORM, RESET_UI} from "../actions";

const defaultState = {
    entities: {
        //carModelId,
        colors:{},
        trims:{},
        carModels:{},
        packages:{},
    },

/*
    entities: {
        carModelId :  "C18CA",
        colors: {
            "197": {
                "color": "197",
                "colorName": "Polar White",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-1.png'),
                "trimList": ['501', '501-1', '501-2', '501-3', '501-4']
            },
            "197-1": {
                "color": "197-1",
                "colorName": "Sky Blue",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-1.png'),
                "trimList": [
                    '501',
                    '501-1',
                ]
            },
            "197-2": {
                "color": "197-2",
                "colorName": "Polar White",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-2.png'),
                "trimList": [
                    '501'
                ]
            },
            "197-3": {
                "color": "197-3",
                "colorName": "0883923230",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-3.png'),
                "trimList": [
                    '501'
                ]
            },
            "197-4": {
                "color": "197-4",
                "colorName": "0883923230",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-4.png'),
                "trimList": [
                    '501'
                ]
            },
            "197-5": {
                "color": "197-5",
                "colorName": "0883923230",
                // "colorImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031641_c-class_c_180_BlueEFFICIENCY_header.jpg",
                colorImage: require('../components/configurator/colors/color-5.png'),
                "trimList": [
                    '501'
                ]
            },
        },

        trims: {
            "501": {
                "trim": "501",
                "trimName": "name 501",
                "trimImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031643_C-Class_c204.jpg",
                "optionList": ['ZG6,ZT1,', 'ZG6,ZT2,']
            },
            "501-1": {
                "trim": "501-1",
                "trimName": "name 501",
                "trimImage": require('../components/configurator/trims/trim-1.png'),
                "optionList": [
                    "ZG6,ZT1,"
                ]
            },
            "501-2": {
                "trim": "501-2",
                "trimName": "name 501",
                "trimImage": require('../components/configurator/trims/trim-2.png'),
                "optionList": [
                    "ZG6,ZT1,"
                ]
            },
            "501-3": {
                "trim": "501-3",
                "trimName": "name 501",
                "trimImage": require('../components/configurator/trims/trim-3.png'),
                "optionList": [
                    "ZG6,ZT1,"
                ]
            },
            "501-4": {
                "trim": "501-4",
                "trimName": "name 501",
                "trimImage": require('../components/configurator/trims/trim-4.png'),
                "optionList": [
                    "ZG6,ZT2,"
                ]
            },
            "501-5": {
                "trim": "501-5",
                "trimName": "name 501",
                "trimImage": require('../components/configurator/trims/trim-5.png'),
                "optionList": [
                    "ZG6,ZT1,"
                ]
            },
        },

        options: {
            "ZG6,ZT1,": {
                "carModelList": ['9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73', '9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-1'],
                "option": "ZG6,ZT1,"
            },
            "ZG6,ZT2,": {
                "carModelList": ['9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-2'],
                "option": "ZG6,ZT2,"
            },
        },

        carModels: {
            "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73": {
                "id": "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73",
                "commission": "0883923230",
                "yearReleased": 2018,
                "carModelName": 'XXXX 4MACTIC COUPE',
                "msrp": 15300000,
                "price": 78200,
                "vehicleType": "COUPE",
                "range": "CLA COUPE (C117)",
                "monthlyLeasingFee": 173600,
                "coverImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031640_c_class1.jpg"
            },
            "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-1": {
                "id": "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-1",
                "commission": "0883923230",
                "yearReleased": 2018,
                "carModelName": 'XXXX 4MACTIC COUPE 2',
                "msrp": 15300000,
                "price": 888889,
                "vehicleType": "COUPE",
                "range": "CLA COUPE (C117)",
                "monthlyLeasingFee": 173600,
                "coverImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031640_c_class1.jpg"
            },
            "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-2": {
                "id": "9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-2",
                "commission": "0883923230",
                "yearReleased": 2018,
                "carModelName": 'XXXX 4MACTIC COUPE 2',
                "msrp": 15300000,
                "price": 78200,
                "vehicleType": "COUPE",
                "range": "CLA COUPE (C117)",
                "monthlyLeasingFee": 173600,
                "coverImage": "http://13.250.199.219/mbfjwebadmin/uploadFiles/20180525_031640_c_class1.jpg"
            }
        }
    },*/
/*
    form: {
        color: "197-2",
        trim: '501-3',
        option: 'ZG6,ZT2,',
        carModel: '9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73'
    },*/

    form: {
        carModel: null,
        carModelName: null,
        color: null,
        trim: null,
        package: null,
    },

    ui: {
        carModels: [],
        carModelName: [],
        colors: [],
        // colors: ['197', '197-1', '197-2', '197-3', '197-4'],
        // colors: ['197-1'],
        // trims: ['501-1', '501-2', '501-3', '501-4', '501-5'],
        // trims: ['501-1'],
        trims: [],
        // options: ['ZG6,ZT1,', 'ZG6,ZT2,'],
        // options: ['ZG6,ZT1,'],
        // options: [],
        // carModels: ['9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73', '9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73-1']
        // carModels: ['9cc120ec-0ebf-4ea9-92d4-5869fb5d1e73']
        packages: []
    },

}

export default (state = defaultState, action) => {
    const {type, payload, error} = action;
    if(error) {
        return state; // Don't do anything if it's an error action
    }


    switch (type) {
        case RESET_FORM:
            return defaultState;          
        case CHANGE_FIELD:
            // state.form[payload.fieldName] = payload.value;
            return {
                ...state,
                form: {
                    ...state.form,
                    [payload.fieldName]: payload.value
                }
            };
        case RESET_UI:
            return defaultState;          
        case CHANGE_UI:
            // state.ui[payload.uiControlName] = payload.value;
            return {
                ...state,
                ui: {
                    ...state.ui,
                    [payload.uiControlName]: payload.value
                }
            };
        case FETCH_CAR_MODEL_DETAILS:



            /**
             *
             * @param array
             * @param idFieldName
             */
            function normalizeArray(array, idFieldName) {
                /**
                 * array = [{color: '1', colorName: 'White'},{color: '2', colorName: 'Black'}], idFieldName
                 *
                 * returns {1: {color: '1', colorName: 'White'}, 2: {color: '2', colorName: 'Black'}}
                 */

                return array.reduce(function (acc, item) {
                    return {
                        ...acc,
                        [item[idFieldName]]: item
                    }
                }, {});
            }

            let allCarModels = payload.carModelDetailList;

            let allColors = (allCarModels.map(item => item.colorList.map(ite => ({ ...item,  ...ite}))))
                .reduce((acc, item) => {
                    return [...acc, ...item];
            }, []);

            let allTrims = allColors.map((item) => item.trimList.map(ite=>({...item, ...ite})))
                .reduce((acc, item) => {
                    return [...acc, ...item];
                }, []);

            let allOptions = allTrims.map((item) => item.optionList.map(ite=>({...item, ...ite})))
                .reduce((acc, item) => {
                    return [...acc, ...item];
                }, []);

            let allPackages = allOptions.map((item) => item.carModelList.map(ite=>({...item, ...ite})))
                .reduce((acc, item) => {
                    return [...acc, ...item];
                }, []).map(item=>({...item, modelClassTypeId: payload.modelClassTypeId, modelClassId: payload.modelClassId}))

                //carModelId: payload.carModelId
            let carModels = normalizeArray(allCarModels.map((item) => {
                let id = item.carModelId;
                return ({
                    id: id,
                    carModelId: item.carModelId,
                    colorList: item.colorList.map(i => `${id}/${i.color}`)
                });
            }), 'id');
            let carModelName = normalizeArray(allCarModels.map((item) => {
                let id = item.carModelId;
                return ({
                    id: id,
                    carModelName: item.carModelName,
                    colorList: item.colorList.map(i => `${id}/${i.color}`)
                });
            }), 'carModelName');
            let colors = normalizeArray(allColors.map((item) => {
                const id = `${item.carModelId}/${item.color}`;
                return ({
                    id: id,
                    color: item.color,
                    colorName: item.colorName,
                    colorImage: item.colorImage,
                    colorPaletteCode: item.colorPaletteCode,
                    trimList: item.trimList.map(i => `${id}/${i.trim}`)
                });
            }), 'id');

            // let allColorList = payload.listOfColorsAtVariantLevel;

            // let colorArray = Object.keys(colors).map((i) => {
            //     return colors[i];
            // });

            // let finalColorList = [];

            // allColorList.forEach((i) => {
            //     let colorz = i.color,
            //         colorName = i.colorName,
            //         colorPaletteCode = i.colorPaletteCode,
            //         trimList = null, id = '';

            //         let name = '';

            //     colorArray.forEach((o) => {
            //         if (o.color === i.color) {
            //             trimList = o.trimList
            //             id = o.id
            //         }
            //         let parts = o.id.split('/');
            //         name = parts[0];
            //     })

            //     if (!id) {
            //         id = name + "/" + i.color
            //     }
            //     finalColorList.push({
            //         color: colorz,
            //         colorName,
            //         colorPaletteCode,
            //         trimList,
            //         id
            //     })
            // })

            // let finalColorObj = finalColorList.reduce((obj, item) => {
            //     return {
            //     ...obj,
            //     [item['id']]: item,
            //     };
            // }, {});

            let trims = normalizeArray(allTrims.map(item => {
                let id = `${item.carModelId}/${item.color}/${item.trim}`;
                return ({
                    id: id,
                    trim: item.trim,
                    trimName: item.trimName,
                    trimImage: item.trimImage,
                    stock: item.optionList[0].availableSlot,
                    packageList: item.optionList
                        .map(i => i.carModelList.map(i => i.id))
                        .reduce((acc, item) => ([...acc, ...item]), [])
                });
            }), 'id');

            let packages = normalizeArray(allPackages.map(item=>({
                id: item.id,

                carModelId: item.carModelId,

                color: item.color,
                colorName: item.colorName,
                colorImage: item.colorImage,
                colorPaletteCode: item.colorPaletteCode,

                trim: item.trim,
                trimName: item.trimName,
                trimImage: item.trimImage,

                option: item.option,

                commission: item.commission,
                coverImage: item.converImage, // the typo is from api!!!
                carModelName: item.carModelName,
                monthlyLeasingFee: item.monthlyLeasingFee,
                msrp: item.msrp,
                yearReleased: item.yearReleased,
                steeringIsRight: item.steeringIsRight,
                selfContribution: item.selfContribution,
                deliveryMonth: item.deliveryMonth,

                modelClassId: payload.modelClassId,
                modelClassTypeId: payload.modelClassTypeId,

                modelClassTypeLable: payload.modelClassTypeLable,
                modelClassLabel: payload.modelClassLabel,

                featureDescription1: item.featureDescription1,
                featureDescription2: item.featureDescription2,
                featureDescription3: item.featureDescription3,

                featureImage1: item.featureImage1,
                featureImage2: item.featureImage2,
                featureImage3: item.featureImage3,

                techSpec1: item.techSpec1,
                techSpec2: item.techSpec2,
                techSpec3: item.techSpec3,
                techSpec4: item.techSpec4,
                techSpec5: item.techSpec5,
                techSpec6: item.techSpec6,

                pdf: item.pdf,
                coeInclusive: item.coeInclusive,
                omvAmount: item.omvAmount,
                preferredColorCode: item.preferredColorCode,
                priceCondition: item.priceCondition

            })), 'id');

            return {
                ...state,
                entities: {
                    ...state.entities,

                    carModels: carModels,
                    carModelName: carModelName,

                    colors: colors,

                    trims: trims,

                    packages: packages
                    // finalColorList: finalColorList
                },
                ui: {
                    ...state.ui,
                    carModels: allCarModels.map(i=>i.carModelId),
                    carModelName:allCarModels.map(i=>i.carModelName),
                    colors: [],
                    trims: [],
                    packages: []
                }
            };
        case 'setDesiredMonth':
            return {
                ...state,
                desiredMonth: payload.desiredMonth
            }
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/calculator.js